import { Course, ExamResultsYesNoEnum } from '../../../Common/entities';
import { ApResultsInputsAnalytics, ApResultsScoreEnum } from '../../entities';

export const mapApResultsInputForAnalytics = (
  courses?: Course[],
  examResults?: Record<string, ApResultsScoreEnum | undefined>,
  isHappyWithResults?: Record<string, ExamResultsYesNoEnum | undefined>,
): ApResultsInputsAnalytics => {
  const examResultsAnalytics: Record<string, string | number> = {};
  const isHappyWithResultsAnalytics: Record<string, string> = {};

  (courses || []).forEach(course => {
    const courseName = course.name;
    const shouldShowScore =
      examResults?.[courseName] !== undefined &&
      examResults?.[courseName] !== ApResultsScoreEnum.NO_TEST;

    const score = shouldShowScore ? `${examResults?.[courseName] ?? ''}` : '';
    let happyValidation = `${isHappyWithResults?.[courseName] ?? ''}`;

    if (examResults?.[courseName] === ApResultsScoreEnum.FIVE) {
      happyValidation = ExamResultsYesNoEnum.YES;
    } else if (
      examResults?.[courseName] === ApResultsScoreEnum.ONE ||
      examResults?.[courseName] === ApResultsScoreEnum.TWO
    ) {
      happyValidation = ExamResultsYesNoEnum.NO;
    }

    examResultsAnalytics[courseName] = score;
    isHappyWithResultsAnalytics[courseName] = happyValidation;
  });

  return {
    examResults: examResultsAnalytics,
    isHappyWithResults: isHappyWithResultsAnalytics,
  };
};
